/* src/app/core/modules/shared/components/fullscreen/fullscreen.component.scss */
/*# sourceMappingURL=/avvera/dev/fullscreen.component.css.map */
